import type { Locale } from '@split/shared';

export type { Locale };
export const LOCALES: readonly Locale[] = ['en', 'es'];
export const LOCALE_STORAGE_KEY = 'split.locale';

/** BCP 47 tag used for `Intl` formatting: `en` uses en-GB grouping (DESIGN 6.1). */
export function intlLocale(locale: Locale): string {
  return locale === 'es' ? 'es-ES' : 'en-GB';
}

export function isLocale(value: unknown): value is Locale {
  return value === 'en' || value === 'es';
}

/** Stored choice, else the browser language, else English. */
export function initialLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch {
    // Storage can be unavailable (private mode); fall through.
  }
  const nav = typeof navigator === 'undefined' ? 'en' : navigator.language;
  return nav.toLowerCase().startsWith('es') ? 'es' : 'en';
}
